import { render, staticRenderFns } from "./intentQuestionDrewer.vue?vue&type=template&id=7c2f7259&scoped=true"
import script from "./intentQuestionDrewer.vue?vue&type=script&lang=js"
export * from "./intentQuestionDrewer.vue?vue&type=script&lang=js"
import style0 from "./intentQuestionDrewer.vue?vue&type=style&index=0&id=7c2f7259&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2f7259",
  null
  
)

export default component.exports